import { Component } from '@angular/core';

@Component({
  selector: '[help-triangle]',
  templateUrl: './help-triangle.component.html',
  styleUrl: './help-triangle.component.scss'
})
export class HelpTriangleComponent {
  public help: boolean = false;

}
